import React, { useState, useRef, useEffect, useContext } from 'react'
import { Box, Button, CircularProgress } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import carCollectedImg from '../assets/car_collected_img.svg'
import locationImg from '../assets/location_img.svg'
import logoWithName from '../assets/logo_with_name.svg'
import DownloadImg from '../assets/download_icon.svg'
import { CAR_ARRIVED, CAR_COLLECTION, CAR_HANDOVER, VEHICLE_RECALL, PARKING_AND_IMAGE_CAPTURE } from '../utils/shareData';
import moment from 'moment';
import { GlobalStateContext } from '../context/globalStateProvider';

const DEFAULT_PARKED_IMAGE = "https://images.parksmart.in/main/Images/ParkingImages/default_parking.jpg"
const PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=in.parksmart.user&hl=en_IN&gl=US&pli=1'
const APP_STORE_LINK = 'https://apps.apple.com/in/app/parksmart-fastag-rto-parking/id1538546356'

const CurrentActivity = ({ bookingDetails, currentActivity, parkingName }) => {
  const theme = useTheme();
  const { setPosition } = useContext(GlobalStateContext)
  const elementRef = useRef(null);

  const recallTimeInSeconds = bookingDetails && bookingDetails.recall_time ? bookingDetails.recall_time * 60 : 900
  const addedMins = moment(currentActivity.timestamp).add(bookingDetails.recall_time, 'minutes')
  const currentTime = moment()
  const remainingSeconds = moment(addedMins, 'YYYY-MM-DD HH:mm').diff(currentTime, 'seconds')

  useEffect(() => {
    const calculatePosition = () => {
      const rect = elementRef.current.getBoundingClientRect();
      const elementBottom = rect.top + window.pageYOffset + elementRef.current.clientHeight;
      setPosition(elementBottom);
    };

    calculatePosition();
    const handleResize = () => calculatePosition()
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); 

  return (
    <Box sx={theme.customStyles.valetCurrentActivityContainer}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <img src={logoWithName} alt='logo' width={80} height={30} />
        <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
          <Box sx={{ color: theme.palette.darkBlue.main, fontSize: "14px", fontWeight: theme.typography.fontWeightSemibold, marginRight: "4px", width: "100px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{parkingName}</Box>
          <img src={locationImg} alt='Location' width={13.5} height={17.5} />
        </Box>
      </Box>

      <Box ref={elementRef} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
        <Box sx={{ color: theme.palette.lightBlack.main, fontSize: "20px", fontWeight: theme.typography.fontWeightSemibold }}>{currentActivity.text}</Box>
        <Box sx={{ color: theme.palette.lightGray.main, fontSize: "12px", fontWeight: theme.typography.fontWeightMedium, marginTop: "10px" }}>{currentActivity.subText}</Box>
        {[CAR_COLLECTION, CAR_ARRIVED, CAR_HANDOVER].includes(currentActivity.name) && <Banner />}
        {[PARKING_AND_IMAGE_CAPTURE].includes(currentActivity.name) && <CarParked imageUrl={currentActivity.imageUrl} />}
        {[VEHICLE_RECALL].includes(currentActivity.name) && <RecallTime recallTimeInSeconds={recallTimeInSeconds} remainingSeconds={remainingSeconds > 0 ? remainingSeconds : 0} />}
      </Box>
    </Box>
  )
}

const Banner = () => (
  <Box sx={{ marginTop: "16px", width: '100%', maxWidth: "450px", height: "152px", overflow: 'hidden' }}>
    <img src={carCollectedImg} alt='Car Collection' style={{ width: "100%", height: "100%" }} />
  </Box>
)
const CarParked = ({ imageUrl }) => {
  const theme = useTheme();
  const { isAndroidAppInstalled, isIosAppInstalled } = useContext(GlobalStateContext)

  const downloadAppHandler = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod|macintosh/.test(userAgent)) {
      window.open(APP_STORE_LINK, '_blank')
    } else if (/android|windows/.test(userAgent)) {
      window.open(PLAY_STORE_LINK, '_blank')
    } else {
      window.open(PLAY_STORE_LINK, '_blank')
    }
    
  }

  return (<Box sx={theme.customStyles.defaultParkingImgContainer}>
    <img style={{ ...theme.customStyles.defaultParkingImgBlur, filter: imageUrl ? "" : "blur(5px)" }} src={(isAndroidAppInstalled || isIosAppInstalled) && imageUrl ? imageUrl : DEFAULT_PARKED_IMAGE} alt="Car Parked" />
    <Box sx={{ ...theme.customStyles.defaultParkingImgOverlay, background: (isAndroidAppInstalled || isIosAppInstalled) && imageUrl ? "rgba(0, 0, 0, 0.30)" : "rgba(0, 0, 0, 0.50)" }}>
      {(isAndroidAppInstalled || isIosAppInstalled) && imageUrl ? null
      //   <Button onClick={() => setVehicleImages([imageUrl])} variant="contained" color="primary" disableElevation sx={{ ...theme.customStyles.viewImageButton }}>
      //   {/* <img src={HandImg} alt='Download' width={16} height={16} /> */}
      //   {/* <Box sx={{ color: "#000000", fontSize: "12px", fontWeight: theme.typography.fontWeightMedium }}>Tap here to View</Box> */}
      // </Button>
        :
        <>
          <Box sx={{ color: theme.palette.white.main, fontSize: "12px", fontWeight: theme.typography.fontWeightMedium }}>Download ParkSmart App to see your car parked image</Box>
          <Button onClick={downloadAppHandler} variant="contained" color="primary" disableElevation sx={{ ...theme.customStyles.gradientButton, marginTop: "8px" }}>
            <img src={DownloadImg} alt='Download' width={24} height={24} />
            <Box sx={{ color: theme.palette.white.main, fontSize: "14px", fontWeight: theme.typography.fontWeightSemibold }}>Download ParkSmart App</Box>
          </Button>
        </>
      }
    </Box>
  </Box>)
}


const RecallTime = ({recallTimeInSeconds = 900, remainingSeconds }) => {
  const theme = useTheme();

  const totalDuration = recallTimeInSeconds;
  const [remainingTime, setRemainingTime] = useState(remainingSeconds);

  useEffect(() => {
    if (remainingTime <= 0) return;

    const interval = setInterval(() => {
      setRemainingTime(prevTime => {
        const newTime = prevTime - 1;
        if (newTime <= 0) {
          clearInterval(interval);
          return 0;
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [remainingTime]);

  const minutes = Math.floor(remainingTime / 60);
  const seconds = remainingTime % 60;
  const elapsedTime = totalDuration - remainingTime;
  const progress = (elapsedTime / totalDuration) * 100;

  return (
    <Box marginTop="16px" position="relative" display="inline-flex">
      <CircularProgress variant="determinate" value={100} size={152} sx={{ color: '#D9D9D9' }} thickness={2.5} />
      <CircularProgress variant="determinate" value={progress} size={152} sx={{ color: theme.palette.green.main, position: 'absolute', left: 0, borderRadius: "10px" }} thickness={2.5} />
      <Box top={0} left={0} bottom={0} right={0} position="absolute" display="flex" alignItems="center" justifyContent="center" flexDirection="column">
        <Box sx={{ fontSize: "12px", color: "#7C7C7C", fontWeight: theme.typography.fontWeightMedium }}>Car arrival at</Box>
        <Box sx={{ fontSize: "24px", color: "#0EAB55", fontWeight: theme.typography.fontWeightSemibold }}>
          {`${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`}
        </Box>
      </Box>
    </Box>
  );
};



export default CurrentActivity